import ContactUsContent from './ContactUsContent';

export default ContactUsContent;
